import axios from 'axios'
import router from '@/router'
import store from '@/store'

// 创建axios实例
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3000',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  const mpAppId = localStorage.getItem('mpAppId') || 'wxe4a9f86db1746b06'
  if (token) {
    config.headers.Authorization = token
  }
  if (mpAppId) {
    config.headers.mpAppId = mpAppId
  }

  // 添加页面和版本信息
  config.headers.Page = window.location.hash
  config.headers.Version = process.env.VUE_APP_VERSION

  return config
})

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    const { headers, data } = response

    // 更新token
    if (headers.token) {
      localStorage.setItem('token', headers.token)
    }

    // 更新用户信息
    if (data._userInfo) {
      store.commit('mStore', {
        name: 'vuex_userInfo',
        value: data._userInfo
      })
    }

    return data
  },
  (error) => {
    // 处理响应错误
    if (!error.response) {
      return Promise.reject(new Error('网络错误，请稍后重试'))
    }

    const { status, data } = error.response

    // 处理401未授权
    if (status === 401) {
      localStorage.removeItem('token')
      const currentRoute = router.currentRoute

      if (currentRoute.path !== '/user/login' && !currentRoute.query.redirect) {
        router.push({
          path: '/user/login',
          query: { redirect: currentRoute.fullPath }
        })
      }
      return Promise.reject(new Error('未登录或登录已过期'))
    }

    // 处理其他错误
    const message = data.message || '系统繁忙，请稍后再试'
    return Promise.reject(new Error(message))
  }
)

// HTTP请求方法
export function get(url, query = {}, config = {}) {
  return axiosInstance.get(url, { params: query, ...config })
}

export function post(url, data = {}, config = {}) {
  return axiosInstance.post(url, data, config)
}

export function sse(url, data = {}, config = {}) {
  return axiosInstance.post(url, data, {
    ...config,
    responseType: 'stream'
  })
}
